/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyLitecoin = createReactComponent("outline", "currency-litecoin", "IconCurrencyLitecoin", [["path", { "d": "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717", "key": "svg-0" }], ["path", { "d": "M14 9l-9 4", "key": "svg-1" }]]);

export { IconCurrencyLitecoin as default };
//# sourceMappingURL=IconCurrencyLitecoin.mjs.map
